import { render } from "./ModalFirmaIntervento.vue?vue&type=template&id=3affc985&scoped=true&ts=true"
import script from "./ModalFirmaIntervento.vue?vue&type=script&lang=ts"
export * from "./ModalFirmaIntervento.vue?vue&type=script&lang=ts"

import "./ModalFirmaIntervento.vue?vue&type=style&index=0&id=3affc985&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1776687441006616365/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3affc985"]])

export default __exports__